import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../../data/pwt";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (e, id) => {
    e.preventDefault();
    setOpen(false);
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-white/80 border-b border-[#E5EBE6]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={(e) => handleNavClick(e, "top")}
          className="flex items-center group"
          aria-label="PWT - Performance With Trust"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_pwt-solutions-1/artifacts/p6xipp7j_PWT_Colori_positivo_orizzontale.png"
            alt="PWT — Performance With Trust"
            className="h-9 md:h-11 w-auto"
            draggable={false}
          />
        </a>

        <ul className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((link) => (
            <li key={link.id}>
              <a
                data-testid={`nav-${link.id}-link`}
                href={`#${link.id}`}
                onClick={(e) => handleNavClick(e, link.id)}
                className="font-sans text-sm font-medium text-[#0A140F] hover:text-[#1A402B] transition-colors"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          data-testid="nav-contact-cta"
          href="#contact"
          onClick={(e) => handleNavClick(e, "contact")}
          className="hidden lg:inline-flex items-center gap-2 px-5 py-2.5 bg-[#1A402B] text-white text-sm font-medium hover:bg-[#255A3C] transition-colors"
        >
          Let&apos;s talk
        </a>

        <button
          type="button"
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 text-[#0A140F] hover:text-[#1A402B] transition-colors"
        >
          {open ? <X size={22} strokeWidth={1.5} /> : <Menu size={22} strokeWidth={1.5} />}
        </button>
      </nav>

      {/* Mobile menu */}
      <div
        data-testid="nav-mobile-panel"
        className={`lg:hidden overflow-hidden transition-[max-height,opacity] duration-500 ease-in-out bg-white border-b border-[#E5EBE6] ${
          open ? "max-h-[520px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <ul className="px-6 py-6 flex flex-col gap-5">
          {NAV_LINKS.map((link) => (
            <li key={link.id}>
              <a
                data-testid={`nav-mobile-${link.id}-link`}
                href={`#${link.id}`}
                onClick={(e) => handleNavClick(e, link.id)}
                className="font-serif text-2xl text-[#0A140F] hover:text-[#1A402B] transition-colors"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
}
